import React from 'react';

const SandClockIcon = () => (
  <svg
    width='10'
    height='14'
    viewBox='0 0 10 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.25 0H1.25C0.918479 0 0.600537 0.131696 0.366117 0.366117C0.131696 0.600537 0 0.918479 0 1.25V3.5C0.000482217 3.69397 0.0458753 3.8852 0.132622 4.05869C0.219369 4.23218 0.345113 4.38323 0.5 4.5L3.5 6.75L0.5 9C0.345113 9.11677 0.219369 9.26782 0.132622 9.44131C0.0458753 9.6148 0.000482217 9.80603 0 10V12.25C0 12.5815 0.131696 12.8995 0.366117 13.1339C0.600537 13.3683 0.918479 13.5 1.25 13.5H8.25C8.58152 13.5 8.89946 13.3683 9.13388 13.1339C9.3683 12.8995 9.5 12.5815 9.5 12.25V10.0225C9.49981 9.82887 9.45494 9.63789 9.36886 9.46445C9.28279 9.291 9.15784 9.13976 9.00375 9.0225L5.99375 6.75L9.00375 4.475C9.15784 4.35774 9.28279 4.2065 9.36886 4.03305C9.45494 3.85961 9.49981 3.66863 9.5 3.475V1.25C9.5 0.918479 9.3683 0.600537 9.13388 0.366117C8.89946 0.131696 8.58152 0 8.25 0ZM8 1.5V2.5H1.5V1.5H8ZM4.75 5.8125L2.33313 4H7.14563L4.75 5.8125ZM8 12H1.5V10.125L4.75 7.6875L8 10.1456V12Z'
      fill='#171717'
      fillOpacity='0.7'
    />
  </svg>
);

export default SandClockIcon;
